// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_angular_material_fesm2022_button_mjs-node_modules_angular_material_fesm2-573687":"894708cbfe45c712","src_app_layouts_login-layout_login-layout_module_ts":"9e779894360203e5","src_app_layouts_admin-layout_admin-layout_module_ts":"17d862c37211345c"}[chunkId] + ".js";
};